const MIN_ROTATION_DEGREES = 0;
const MAX_ROTATION_DEGREES = 359;

export function normalizeRotation(value: unknown): number {
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return 0;
  const rounded = Math.round(num);
  return Math.min(MAX_ROTATION_DEGREES, Math.max(MIN_ROTATION_DEGREES, rounded));
}

export function buildBlockTransform(x: number, y: number, rotation?: number): string {
  const normalizedRotation = normalizeRotation(rotation);
  const translate = `translate(${x}px, ${y}px)`;
  return normalizedRotation !== 0 ? `${translate} rotate(${normalizedRotation}deg)` : translate;
}
